import React from 'react';

type AttachmentIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function AttachmentIcon({
  onClick,
  className = ''
}: AttachmentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M5.01758 17.7964C3.67529 17.7959 2.41406 17.2739 1.46826 16.3267C0.52148 15.3804 0 14.1196 0 12.7773C0 11.4346 0.52148 10.1738 1.46875 9.22705L9.48047 1.22705C10.2715 0.43603 11.2847 0 12.3335 0C13.3545 0 14.2305 0.35791 14.9365 1.06445C15.7207 1.84863 16.0913 2.86621 15.98 3.92968C15.8828 4.85546 15.4365 5.75829 14.7222 6.47118L9.38575 11.793C9.31397 11.8706 8.48194 12.7324 7.37647 12.7524C6.77149 12.772 6.21778 12.5239 5.75342 12.0596C4.54346 10.8491 4.89746 9.41112 5.78565 8.52343L10.2915 4.00146C10.584 3.70849 11.0586 3.70654 11.3521 3.99951C11.6455 4.29199 11.6465 4.7666 11.354 5.06006L6.84717 9.58301C6.51612 9.91406 6.24268 10.4272 6.81397 10.999C7.0459 11.23 7.24512 11.2612 7.34473 11.2529C7.74414 11.2481 8.18604 10.8774 8.30957 10.7481L13.6626 5.40919C14.127 4.94581 14.4277 4.34962 14.4883 3.77345C14.5532 3.15089 14.3472 2.59669 13.876 2.12501C13.4551 1.7046 12.9507 1.50001 12.3335 1.50001C11.6855 1.50001 11.0488 1.7798 10.5405 2.2881L2.52881 10.2881C1.86524 10.9512 1.5 11.8355 1.5 12.7774C1.5 13.7188 1.86523 14.603 2.5293 15.2666C3.19239 15.9307 4.07569 16.2959 5.0166 16.2964C5.95849 16.2964 6.84375 15.9307 7.50733 15.2666L14.4805 8.29395C14.7734 8.00098 15.2481 8.00098 15.541 8.29395C15.834 8.58692 15.834 9.06153 15.541 9.3545L8.56788 16.3272C7.6211 17.2744 6.36035 17.7964 5.01758 17.7964Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default AttachmentIcon;
